import React from "react";
import PropTypes from "prop-types";

/**
 * Icons that can easily be reused in all the project
 */
const BinIcon = ({ size, color, marginRight, ...props }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="2 2 16 16"
    xmlSpace="preserve"
    width={`${size}`}
    height={`${size}`}
    style={{ marginRight }}
    {...props}
  >
    <path
      d="M16.4062 4.53125C16.6406 4.53125 16.8164 4.70703 16.8164 4.94141V6.97266C16.8164 7.1875 16.6406 7.38281 16.4062 7.38281H15.4688V15.6055C15.4688 16.6602 14.6094 17.5 13.5742 17.5H6.42578C5.91797 17.5 5.44922 17.3047 5.09766 16.9531C4.72656 16.6016 4.53125 16.1133 4.53125 15.6055V7.38281H3.59375C3.35938 7.38281 3.18359 7.1875 3.18359 6.97266V4.94141C3.18359 4.70703 3.35938 4.53125 3.59375 4.53125H7.22656V2.91016C7.22656 2.69531 7.40234 2.5 7.63672 2.5H12.3633C12.5977 2.5 12.7734 2.69531 12.7734 2.91016V4.53125H16.4062ZM8.06641 3.33984V4.53125H11.9336V3.33984H8.06641ZM15.9961 6.54297V5.35156H4.00391V6.54297H15.9961ZM14.6484 15.6055V7.38281H5.35156V15.6055C5.35156 15.8984 5.46875 16.1523 5.68359 16.3672C5.87891 16.5625 6.13281 16.6602 6.42578 16.6602H13.5742C14.1797 16.6406 14.6289 16.1914 14.6484 15.6055ZM7.63672 15.4688C7.40234 15.4688 7.22656 15.293 7.22656 15.0586V8.98438C7.22656 8.76953 7.40234 8.57422 7.63672 8.57422C7.87109 8.57422 8.06641 8.76953 8.06641 8.98438V15.0586C8.06641 15.293 7.87109 15.4688 7.63672 15.4688ZM10 15.4688C9.76562 15.4688 9.58984 15.293 9.58984 15.0586V8.98438C9.58984 8.76953 9.76562 8.57422 10 8.57422C10.2344 8.57422 10.4102 8.76953 10.4102 8.98438V15.0586C10.4102 15.293 10.2344 15.4688 10 15.4688ZM12.3633 15.4688C12.1289 15.4688 11.9336 15.293 11.9336 15.0586V8.98438C11.9336 8.76953 12.1289 8.57422 12.3633 8.57422C12.5977 8.57422 12.7734 8.76953 12.7734 8.98438V15.0586C12.7734 15.293 12.5977 15.4688 12.3633 15.4688Z"
      fill={color}
    />
  </svg>
);

BinIcon.propTypes = {
  /**
   * What background color to use
   */
  color: PropTypes.string,
  /**
   * How large should the icon be?
   */
  size: PropTypes.number,
  /**
   * Margin at the right of the icon
   */
  marginRight: PropTypes.number
};

BinIcon.defaultProps = {
  color: "#ffffff",
  size: 20,
  marginRight: 0
};

export default BinIcon;
